module.exports = __webpack_public_path__ + "static/img/04.0dc35f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/04.png
// module id = vZ3Z
// module chunks = 0